import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";
import CustomText from "./CustomText";
import { Svg, Circle } from "react-native-svg";
import { web } from "../accessories/Platform";

const CircleProgressBar = ({ progress }) => {
  const isMobileWeb = Dimensions.get("window").width <= 480;
  const CircularProgress = ({ progress, radius, strokeWidth }) => {
    const circumference = 2 * Math.PI * (radius - strokeWidth);
    const progressValue = (progress / 100) * circumference;

    return (
      <>
        <View
          style={
            web ? { rotate: "-88deg" } : { transform: [{ rotate: "-88deg" }] }
          }
        >
          <Svg width={radius * 2} height={radius * 2}>
            <Circle
              cx={radius}
              cy={radius}
              r={radius - strokeWidth}
              stroke="#dddddd" // Background color of the progress bar
              strokeWidth={strokeWidth}
            />
            <Circle
              cx={radius}
              cy={
                radius +
                (progress > 69
                  ? 1.5
                  : progress > 49
                  ? 1
                  : progress > 24
                  ? 0.8
                  : 0.5)
              }
              r={radius - strokeWidth}
              fill="#fff"
              stroke="#89af54" // Color of the progress bar
              strokeWidth={strokeWidth}
              strokeDasharray={circumference}
              strokeDashoffset={circumference - progressValue}
              strokeLinecap="butt"
            />
          </Svg>
        </View>
        <View
          style={{
            top: !isMobileWeb && web ? -46 : -41.5,
            left: 1,
            backgroundColor: "#fff",
            width: !isMobileWeb && web ? 36 : 33,
            height: !isMobileWeb && web ? 36 : 33,
            borderRadius: 50,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CustomText
            bold={true}
            style={{
              color: "#89af54",
              // top: 9,
              // left: 8,
              // position: "absolute",
              fontSize: !isMobileWeb && web ? 13 : 9,
            }}
          >
            {progress}%
          </CustomText>
        </View>
      </>
    );
  };
  return (
    <CircularProgress
      progress={progress}
      radius={!isMobileWeb && web ? 28 : 25}
      strokeWidth={8}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "center",
  },
});
export default CircleProgressBar;
